import { Animation } from './animation.model';
import { BackgroundMedia } from './background-media.model';
import { Border } from './border.model';
import { Css } from './css.model';
import { Link } from './link.model';
import { Margin } from './margin.model';
import { Padding } from './padding.model';

export class Column {
  FullWidth: boolean = false;
  DesktopWidth?: string;
  TabletWidth?: string;
  MobileWidth?: string;
  AlignmentType?: string;
  JustifyContent?: string;
  AlignItems?: string;
  HorizontalContent: boolean = false;
  // Padding?: Padding;
  // Margin?: Margin;
  // Border?: Border;
  BackgroundMedia?: BackgroundMedia;
  Css?: Css;
  Link?: Link;
  Animation?: Animation;
  Styles?: string[];
  ColWidthClass?: string;
}
